import React, { useState, useEffect } from 'react';

const withGlobalDialog = (WrapComponent, setDialog) => (props) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setDialog({
      show: () => {
        setOpen(true);
      },
      hide: () => {
        setOpen(false);
      },
    });
  });

  return (
    <WrapComponent open={open} {...props} />
  );
};

export default withGlobalDialog;
